import { z } from 'zod';

export const Acquirer = z.enum(['CARD', 'CARD_RUB', 'TEST', 'P2P']);
export type Acquirer = z.infer<typeof Acquirer>;
